import { CART_URL } from 'SourceRoute/CartPage/CartPage.config';

export { CART_URL };
export const EMPTY_CART_CONFIRM_POPUP_ID = 'EMPTY_CART_CONFIRM_POPUP_ID';
